/*
 * ********************************************************************
 *  GlobePayroll Confkeyential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbkeyden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */
import {AllEmpContractsMetaData} from '../+ess/employee-self.service';
import {AnyData} from '../shared/api';
import {FieldType} from '../shared/form-generator/fields/fields.interfaces';

export interface NavigationParam {
  path: string;
  params: {
    id: number;
    tab?: string;
  };
}

export interface Absence {
  id?: number;
  begin?: string;
  end?: string;
  beginDayfactor?: number;
  endDayfactor?: number;
  cliCoreID?: number;
  type?: string;
  updatedate?: Date | string;
  empContract?: number;
}

export interface TALine {
  contractId?: number;
  firstName?: string;
  lastName?: string;
  contractName?: string;
  absences?: Array<Absence>;
}

export interface ContractData {
  contractId: number;
  contractData: [{
    default?: boolean;
    id?: number;
    beginDate: string;
    groupName: string;
    endDate: string;
    values: { [key: string]: EmpZoneEmpData };
    dated: boolean;
  }];
}

export interface MDUSavePayload {
  groupNameTransId: string;
  tabNameTransId: string;
  occurrenceType: string;
  occurrenceDate: string;
  name?: string;
  contracts: ContractData[];
  description?: string;
}

export interface EmpZoneGroupEmpDataResponse {
  entities: EmpZoneGroupEmpData<EmpZoneEmpDataValues<string>>[];
  totalCount: number;
}

export interface EmpZoneGroupEmpContractData {
  id: number;
  cliEmp: {
    id: number;
    simpleContracts: AllEmpContractsMetaData[];
  };
  data: EmpZoneGroupEmpData<EmpZoneEmpDataValues<string>>[];
}

export interface EmpZoneGroupEmpData<T> {
  id?: number;
  dated?: boolean;
  beginDate?: string;
  endDate?: string;
  updateDate?: string;
  groupZoneType?: string;
  groupName?: string;
  contractId?: number;
  values: T;
  allEmpContractsMetaData?: AllEmpContractsMetaData[];
  default?: boolean;
  groupZoneKeyDelete: boolean;
  repInherited: boolean;
}

export interface EmpZoneEmpData {
  value: string | number | boolean;
  type: string;
  transId?: string;
}

export type EmpZoneEmpDataValues<K extends string> = {
  [key in K]: EmpZoneEmpData;
};

export interface GridRawDataValues<K extends string> {
  empInfo: { [key in K]: EmpZoneEmpData };
  beginDate?: string;
  endDate?: string;
  empZoneInfo: { [key in K]: EmpZoneEmpData };
}


export interface GpHotTableColumn {
  data: string;
  type: string;
  originalType?: FieldType;
  dateFormat?: string;
  readOnly?: boolean;
  renderer?: string;
  validator?: AnyData;
  columnSorting?: boolean | { headerAction?: boolean; indicator?: boolean; compareFunctionFactory?: AnyData };
  isFile?: boolean;
}

export enum HotTableDataType {
  AUTOCOMPLETE = 'autocomplete',
  CHECKBOX = 'checkbox',
  DATE = 'date',
  DROPDOWN = 'dropdown',
  NUMERIC = 'numeric',
  TEXT = 'text',
  HTML = 'html'
}

export const DATA_TYPES_EXCLUDED = [FieldType.BREAK_LINE.toString()];

